import { useFormContext } from 'react-hook-form'

import { toISO8601 } from '@fortem-monorepo/js-utilities'
import { DatePicker } from '@fortem-monorepo/react-ui'
import { FormError } from '@fortem-monorepo/react-ui'
import { FormField, FormItem, FormLabel } from '@fortem-monorepo/react-ui'

export interface PenultimateFloaterSettlementDateFieldProps {}

export const PenultimateFloaterSettlementDateField: React.FC<
  PenultimateFloaterSettlementDateFieldProps
> = ({}) => {
  const { control, setValue } = useFormContext<{ penultimate_floater_settlement_date: string }>()

  return (
    <FormField
      name="penultimate_floater_settlement_date"
      control={control}
      render={({ field: { value } }) => {
        return (
          <FormItem>
            <div className="flex items-center gap-2">
              <FormLabel>Penultimate Floater Sett Date</FormLabel>
              <FormError />
            </div>
            <DatePicker
              placeholder={'Choose a date'}
              selected={value ? new Date(value) : undefined}
              onSelect={(date) =>
                date &&
                setValue('penultimate_floater_settlement_date', toISO8601(date), {
                  shouldValidate: true,
                })
              }
            />
          </FormItem>
        )
      }}
    />
  )
}
